import React from 'react';

import './InsurancePackage.scss';
import { Package } from '../../interfaces/Types';
import { FullCoverageCollection } from '../../interfaces/Types';
import InsuranceTileContent from './InsuranceTileContent/InsuranceTileContent';
import InsuranceTileFooter from './InsuranceTileFooter/InsuranceTileFooter';
import InsuranceTileHeader from './InsuranceTileHeader/InsuranceTileHeader';

interface Props {
  data: Package;
  fullCoverageList?: FullCoverageCollection[];
  selectedCoverage?: string;
  isExpanded?: boolean;
  priceLabel: string;
  oldPriceLabel: string;
  packageTitle: string;
  additionalInfos: string[];
  //shouldDisplayAddOnPlusSign?: boolean;
  /**
   * Handle side effects of updating the Tile selection
   */
  updateTileSelection: (selectedTile: any) => void;
}

export type ComponentProps = Props;

const InsurancePackage: React.FC<ComponentProps> = (props) => {
  return (
    <div
      className="package-container additional-package"
    >
      <InsuranceTileHeader
        updateTileSelection={props.updateTileSelection}
        data={props.data}
        priceLabel={props.priceLabel}
        oldPriceLabel={props.oldPriceLabel}
        additionalInfos={props.additionalInfos}
        packageTitle={props.packageTitle}
        //shouldDisplayAddOnPlusSign={props.shouldDisplayAddOnPlusSign}
      />
      <InsuranceTileContent
        data={props.data}
      />
      <InsuranceTileFooter
        updateTileSelection={props.updateTileSelection}
        data={props.data}
      />
    </div>
  );
};
export default InsurancePackage;
